// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Repay = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.906 9.562a1.969 1.969 0 1 1 0 3.937 1.969 1.969 0 0 1 0-3.937"
    />
    <path
      stroke="currentColor"
      d="M3.758 2.812H.945v3.937h2.813M8.258 6.187h2.13l3.965.89c1.43.32 2.165-.156 2.702-1.547L13.32 3.937l-4.5-1.125H3.758v3.937l1.758 1.758A1.69 1.69 0 0 0 6.71 9c1.318 0 4.922-1.406 4.922-1.406a1.406 1.406 0 0 0-1.406-1.406z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.938 11.44a1.968 1.968 0 1 0 1.124 1.869"
    />
  </svg>
);
const ForwardRef = forwardRef(Repay);
export default ForwardRef;
